import {
    SHOW_LOADING,
    SHOW_PROFILE,
    SHOW_STORY,
    SHOW_RECEIPT
} from 'shared/actions/types';

export const showProfile = () => dispatch => {
    dispatch({
        type: SHOW_PROFILE
    });
}

export const showStory = () => dispatch => {
    dispatch({
        type: SHOW_STORY
    });
}

export const showLoading = (visible) => dispatch => {
    dispatch({
        type: SHOW_LOADING,
        payload: visible
    });
}

export const showReceipt = (purchase) => dispatch => {
    dispatch({
        type: SHOW_RECEIPT,
        payload: purchase
    });
}